import "./utilities_namespace.js";

// Return a browser descriptor for the given userAgent string.
// If a userAgent is not provided it will default to the current userAgent.
//
// see https://stackoverflow.com/a/56361977

window.Sparkle ??= {};
window.Sparkle.Embed ??= {};
window.Sparkle.Embed.Utilities ??= {};

Sparkle.Embed.Utilities.browser = function (userAgent) {
  var agent = (userAgent || window.navigator.userAgent).toLowerCase();

  switch (true) {
    case agent.indexOf("edge") > -1:
      return "edge";
    case agent.indexOf("edg/") > -1:
      return "edge-legacy"; // Match also / to avoid matching for the older Edge
    case agent.indexOf("opr") > -1 && !!window.opr:
      return "opera";
    case agent.indexOf("chrome") > -1 && !!window.chrome:
      return "chrome";
    case agent.indexOf("trident") > -1:
      return "ie";
    case agent.indexOf("firefox") > -1:
      return "firefox";
    case agent.indexOf("safari") > -1:
      return "safari";
    default:
      return "other";
  }
};

// Return true if the userAgent is a MS Edge browser legacy or current, return false otherwise.
Sparkle.Embed.Utilities.isEdge = function (userAgent) {
  return Sparkle.Embed.Utilities.browser(userAgent).startsWith("edge");
};
